import { render, staticRenderFns } from "./Detail-list.vue?vue&type=template&id=b5011d34&scoped=true&"
import script from "./Detail-list.vue?vue&type=script&lang=js&"
export * from "./Detail-list.vue?vue&type=script&lang=js&"
import style0 from "./Detail-list.vue?vue&type=style&index=0&id=b5011d34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5011d34",
  null
  
)

export default component.exports